module.exports = __webpack_public_path__ + "static/itsm_ad_3-a5993fae6cdc6dd9181f5e6b8733ed2e.png";